import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";
import { useAppStore } from "@/pinia/app";
import { SubscriptionModule } from "@/types";

interface Props {
  moduleIds: number[];
  profileClickEnabled: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSubModuleChips',
  props: {
    moduleIds: null,
    profileClickEnabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  moduleIds: number[];
  profileClickEnabled: boolean;
};


const { moduleIds, profileClickEnabled } = toRefs(props);

const appStore = useAppStore();

const modules = computed(() => {
  const list: SubscriptionModule[] = [];

  moduleIds.value.forEach((id) => {
    const module = appStore.lookupTables.subscriptionModules.find(
      (m) => id === m.id
    );
    if (module) {
      const index = list.findIndex(
        (m) => module.abbreviation === m.abbreviation
      );
      const isUniqueInList = index === -1;
      if (isUniqueInList) {
        list.push(module);
      } else {
        const other = list[index];
        list.splice(index, 1, {
          id: 3,
          name: `${other.name} <br> ${module.name}`,
          abbreviation: "Other",
        });
      }
    }
  });

  return list.sort((a, b) => a.id - b.id);
});

return { __sfc: true,props, moduleIds, profileClickEnabled, appStore, modules }
}

})